import './styles/styles.scss';
import '@/chrono/styles/styles.scss';

import React, { useEffect } from 'react';
import TagManager from 'react-gtm-module';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import ToastWrapper from '@/common/components/molecules/ToastWrapper/ToastWrapper';
import { DATA_LAYER_NAME } from '@/common/constants';
import { useConfig } from '@/common/contexts/ConfigContext';
import useTheme from '@/common/hooks/useTheme';
import SessionStorageAuth from '@/common/services/SessionStorage.auth';
import SessionStorageUser from '@/common/services/SessionStorage.user';

import Router from './router';

const App = () => {
  const { t } = useTranslation();
  const { env, isChrono } = useConfig();
  const { favicon, touch, manifest } = useTheme();

  const authService = SessionStorageAuth.getService();
  const userService = SessionStorageUser.getService();

  useEffect(() => {
    TagManager.initialize({
      gtmId: isChrono
        ? process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID_CHRONO
        : process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID_EBAT,
      dataLayerName: DATA_LAYER_NAME,
    });
  }, [env, isChrono]);

  useEffect(() => {
    const token = authService.getAccessToken();
    // eslint-disable-next-line camelcase
    const refresh_token = authService.getRefreshToken();
    const user = userService.getUserDataFromToken();

    // eslint-disable-next-line camelcase
    if (token && refresh_token && user) {
      window.parent.postMessage({ token, refresh_token, user }, '*');
    }
  });

  return (
    <>
      <Helmet>
        <title>{t(`${env}:messages.title`)}</title>
        <link rel="icon" href={favicon} />
        <link rel="apple-touch-icon" href={touch} />
        <link rel="manifest" href={manifest} crossOrigin="use-credentials" />
      </Helmet>
      <Router />

      <ToastWrapper />
    </>
  );
};

export default App;
